import { CARAVAN_TRIP } from '../config/trip'

export type DarijaEntry = {
  id: string
  expression: string
  meaning: string
  transcription: string
  dailyGroup: string
  category: 'saluer' | 'politesse' | 'direction' | 'marche' | 'manger' | 'aide'
  favoriteDefault: boolean
  pronunciationVerified: boolean
  audioPath: string | null
  audioMode: 'none' | 'platform_tts' | 'human_recording'
  audioLocale: 'ar-MA'
  revision: number
}

const DEFAULT_DARIJA_ROWS = [
  ['salam', 'سلام', 'Bonjour', 'Salam', 'saluer', true],
  ['sabah-lkhir', 'صباح الخير', 'Bonjour (le matin)', 'Sbah l-khir', 'saluer', false],
  ['msa-lkhir', 'مسا الخير', 'Bonsoir', 'Msa l-khir', 'saluer', false],
  ['bslama', 'بسلامة', 'Au revoir', 'Bslama', 'saluer', true],
  ['choukrane', 'شكرا', 'Merci', 'Choukrane', 'politesse', true],
  ['afak', 'عافاك', 'S’il vous plaît', 'Afak', 'politesse', true],
  ['smah-liya', 'سمح ليا', 'Excusez-moi', 'Smah liya', 'politesse', true],
  ['wakha', 'واخا', 'D’accord', 'Wakha', 'politesse', false],
  ['fin', 'فين كاين؟', 'Où se trouve… ?', 'Fin kayn… ?', 'direction', true],
  ['lissar', 'اليسار', 'À gauche', 'Lissar', 'direction', false],
  ['limen', 'اليمين', 'À droite', 'Limen', 'direction', false],
  ['nishan', 'نيشان', 'Tout droit', 'Nishan', 'direction', false],
  ['bchhal', 'بشحال؟', 'Combien ?', 'Bchhal ?', 'marche', true],
  ['nqess', 'نقص شوية', 'Un peu moins, s’il vous plaît', 'Nqess chwiya', 'marche', false],
  ['sifr', 'صفر', 'Zéro', 'Sifr', 'marche', false],
  ['wahed', 'واحد', 'Un', 'Wahed', 'marche', false],
  ['jouj', 'جوج', 'Deux', 'Jouj', 'marche', false],
  ['tlata', 'ثلاثة', 'Trois', 'Tlata', 'marche', false],
  ['rbaa', 'ربعة', 'Quatre', 'Rb‘a', 'marche', false],
  ['khmsa', 'خمسة', 'Cinq', 'Khmsa', 'marche', false],
  ['stta', 'ستة', 'Six', 'Stta', 'marche', false],
  ['sbaa', 'سبعة', 'Sept', 'Sb‘a', 'marche', false],
  ['tmnya', 'ثمنية', 'Huit', 'Tmnya', 'marche', false],
  ['tsoud', 'تسعود', 'Neuf', 'Ts‘oud', 'marche', false],
  ['achra', 'عشرة', 'Dix', '‘Chra', 'marche', false],
  ['byed', 'بيض', 'Blanc', 'Byed', 'marche', false],
  ['zreq', 'زرق', 'Bleu', 'Zreq', 'marche', false],
  ['khel', 'كحل', 'Noir', 'Khel', 'marche', false],
  ['hmer', 'حمر', 'Rouge', 'Hmer', 'marche', false],
  ['sfer', 'صفر', 'Jaune', 'Sfer', 'marche', false],
  ['khder', 'خضر', 'Vert', 'Khder', 'marche', false],
  ['ghali-bzzaf', 'غالي بزاف', 'C’est trop cher', 'Ghali bzzaf', 'marche', true],
  ['lma', 'الما', 'De l’eau', 'L-ma', 'manger', true],
  ['atay', 'أتاي', 'Du thé', 'Atay', 'manger', false],
  ['bghit', 'بغيت…', 'Je voudrais…', 'Bghit…', 'manger', true],
  ['lhssab', 'الحساب عافاك', 'L’addition, s’il vous plaît', 'L-hssab afak', 'manger', true],
  ['ma-fhemtch', 'ما فهمتش', 'Je n’ai pas compris', 'Ma fhemtch', 'aide', true],
  ['chwiya', 'هضر بشوية', 'Parlez doucement', 'Hder b-chwiya', 'aide', true],
  ['iyyeh', 'إيه', 'Oui', 'Iyyeh', 'politesse', false],
  ['la', 'لا', 'Non', 'La', 'politesse', false],
  ['hna', 'هنا', 'Ici', 'Hna', 'direction', false],
  ['qrib', 'قريب', 'Près', 'Qrib', 'direction', false],
  ['baid', 'بعيد', 'Loin', 'B‘id', 'direction', false],
  ['wqef-hna', 'وقف هنا', 'Arrêtez-vous ici', 'Wqef hna', 'direction', true],
  ['khobz', 'الخبز', 'Du pain', 'L-khobz', 'manger', false],
  ['qahwa', 'قهوة', 'Du café', 'Qahwa', 'manger', false],
  ['hlip', 'حليب', 'Du lait', 'Hlib', 'manger', false],
  ['bnin', 'بنين', 'C’est bon', 'Bnin', 'manger', false],
  ['djaj', 'الدجاج', 'Du poulet', 'D-djaj', 'manger', false],
  ['lbgri', 'البقري', 'Du bœuf', 'L-bgri', 'manger', false],
  ['lmaazi', 'المعزي', 'De la chèvre', 'L-m‘zi', 'manger', false],
  ['lghnmi', 'الغنمي', 'De l’agneau', 'L-ghnmi', 'manger', false],
  ['lhout', 'الحوت', 'Du poisson', 'L-hout', 'manger', false],
  ['tajin', 'الطاجين', 'Un tajine', 'T-tajin', 'manger', false],
  ['ksksou', 'الكسكسو', 'Du couscous', 'L-ksksou', 'manger', false],
  ['hrira', 'الحريرة', 'De la harira', 'L-hrira', 'manger', false],
  ['msemen', 'المسمن', 'Du msemen', 'L-msemen', 'manger', false],
  ['qotban', 'القطبان', 'Des brochettes', 'L-qotban', 'manger', false],
  ['bstila', 'البسطيلة', 'De la pastilla', 'L-bstila', 'manger', false],
  ['kfta', 'الكفتة', 'De la kefta', 'L-kfta', 'manger', false],
  ['frit', 'الفريت', 'Des frites', 'L-frit', 'manger', false],
  ['bla-lhem', 'بلا لحم', 'Sans viande', 'Bla lhem', 'manger', true],
  ['makla-bla-lhem', 'واش كاينة شي ماكلة بلا لحم؟', 'Il y a un plat sans viande ?', 'Wech kayna chi makla bla lhem ?', 'manger', true],
  ['harr', 'حار', 'Épicé', 'Harr', 'manger', false],
  ['ma-harrch', 'ما يكونش حار', 'Pas épicé', 'Ma-y-kounch harr', 'manger', true],
  ['maa', 'بـ', 'Avec…', 'B…', 'manger', false],
  ['bla', 'بلا', 'Sans…', 'Bla…', 'manger', false],
  ['awni', 'عاوني', 'Aidez-moi', '‘Awni', 'aide', true],
  ['ma-areftch', 'ما عرفتش', 'Je ne sais pas', 'Ma ‘reftch', 'aide', false],
  ['bla-jmil', 'بلا جميل', 'De rien', 'Bla jmil', 'politesse', false],
  ['fin-bit-lma', 'فين بيت الما؟', 'Où sont les toilettes ?', 'Fin bit l-ma ?', 'aide', true],
] as const

const DARIJA_DAILY_GROUP_BY_ID: Readonly<Record<string, string>> = Object.freeze({
  sifr: 'nombres-0-5', wahed: 'nombres-0-5', jouj: 'nombres-0-5', tlata: 'nombres-0-5', rbaa: 'nombres-0-5', khmsa: 'nombres-0-5',
  stta: 'nombres-6-10', sbaa: 'nombres-6-10', tmnya: 'nombres-6-10', tsoud: 'nombres-6-10', achra: 'nombres-6-10',
  byed: 'couleurs', zreq: 'couleurs', khel: 'couleurs', hmer: 'couleurs', sfer: 'couleurs', khder: 'couleurs',
  djaj: 'viandes', lbgri: 'viandes', lmaazi: 'viandes', lghnmi: 'viandes', lhout: 'viandes',
  tajin: 'plats', ksksou: 'plats', hrira: 'plats', msemen: 'plats', qotban: 'plats', bstila: 'plats', kfta: 'plats', frit: 'plats',
  'ghali-bzzaf': 'phrases-utiles', 'bla-lhem': 'phrases-utiles', 'makla-bla-lhem': 'phrases-utiles', harr: 'phrases-utiles',
  'ma-harrch': 'phrases-utiles', maa: 'phrases-utiles', bla: 'phrases-utiles', 'bla-jmil': 'phrases-utiles', 'fin-bit-lma': 'phrases-utiles',
})

export const DEFAULT_DARIJA_ENTRIES: readonly DarijaEntry[] = createDarijaLexicon(DEFAULT_DARIJA_ROWS.map(
  ([id, expression, meaning, transcription, category, favoriteDefault]) => ({
  id, expression, meaning, transcription,
  dailyGroup: DARIJA_DAILY_GROUP_BY_ID[id] ?? category, category, favoriteDefault,
  pronunciationVerified: false, audioPath: null, audioMode: 'platform_tts' as const, audioLocale: 'ar-MA' as const, revision: 2,
  })),
)

function requiredText(value: unknown, label: string): string {
  if (typeof value !== 'string' || value.trim().length === 0) throw new Error(`${label} darija manquant.`)
  return value.trim()
}

export function createDarijaLexicon(entries: readonly DarijaEntry[]): readonly DarijaEntry[] {
  if (entries.length === 0) throw new Error('Le lexique darija ne peut pas être vide.')
  const ids = new Set<string>()
  const normalized = entries.map((entry) => {
    const id = requiredText(entry.id, 'Identifiant')
    if (ids.has(id)) throw new Error('Chaque entrée darija doit avoir un identifiant distinct.')
    ids.add(id)
    if (!['saluer', 'politesse', 'direction', 'marche', 'manger', 'aide'].includes(entry.category)) throw new Error('Catégorie darija invalide.')
    if (!['none', 'platform_tts', 'human_recording'].includes(entry.audioMode)) throw new Error('Mode audio darija invalide.')
    if (entry.audioMode === 'human_recording' && entry.audioPath === null) throw new Error('Un enregistrement darija exige un fichier audio.')
    if (entry.audioMode !== 'human_recording' && entry.audioPath !== null) throw new Error('Le chemin audio est réservé aux enregistrements.')
    if (!Number.isInteger(entry.revision) || entry.revision < 1) throw new Error('Révision darija invalide.')
    return Object.freeze({
      id,
      expression: requiredText(entry.expression, 'Expression'),
      meaning: requiredText(entry.meaning, 'Traduction'),
      transcription: requiredText(entry.transcription, 'Transcription'),
      dailyGroup: requiredText(entry.dailyGroup, 'Groupe quotidien'),
      category: entry.category,
      favoriteDefault: entry.favoriteDefault,
      pronunciationVerified: entry.pronunciationVerified,
      audioPath: entry.audioPath,
      audioMode: entry.audioMode,
      audioLocale: entry.audioLocale,
      revision: entry.revision,
    })
  })
  return Object.freeze(normalized)
}

export function selectDailyDarijaGroup(
  entries: readonly DarijaEntry[],
  productDay: string,
): readonly DarijaEntry[] {
  const lexicon = createDarijaLexicon(entries)
  const groups = [...new Set(lexicon.map((entry) => entry.dailyGroup))]
  const dayNumber = Math.floor(Date.parse(`${productDay}T00:00:00.000Z`) / 86_400_000)
  const tripStartDay = Math.floor(Date.parse(`${CARAVAN_TRIP.startsOn}T00:00:00.000Z`) / 86_400_000)
  const index = Math.abs(Number.isFinite(dayNumber) ? dayNumber - tripStartDay : 0) % groups.length
  const selectedGroup = groups[index]
  return Object.freeze(lexicon.filter((entry) => entry.dailyGroup === selectedGroup))
}
